module.exports = __webpack_public_path__ + "static/media/gridicons_print.1b69280f.svg";